<div class="card {{ class }}" [style]="cardStyles">
  <div class="card-header {{ headerCSSClass }}" [style]="headerStyles" *ngIf="showHeader">
    <ng-content select="[header]"></ng-content>
  </div>
  <div class="card-body card-body--with-header {{ bodyCSSClass }}" [style]="bodyStyles">
    <ng-content select="[body]"></ng-content>
  </div>
  <div class="card-footer {{ footerCSSClass }}" [style]="footerStyles" *ngIf="showFooter">
    <ng-content select="[footer]"></ng-content>
  </div>
</div>
